import { render, staticRenderFns } from "./CapacitadoresComponents.vue?vue&type=template&id=61daee2d"
import script from "./CapacitadoresComponents.vue?vue&type=script&lang=js"
export * from "./CapacitadoresComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports